import { z } from 'zod';

/**
 * Tenant data schema for API responses
 */
export const TenantDataSchema = z.object({
  tenantId: z.string().uuid(),
  tenantName: z.string().min(1),
  subdomain: z.string().min(1),
  isActive: z.boolean(),
  hasSubscription: z.boolean().optional(),
  subscriptionStatus: z.string().nullable().optional(),
  accessReason: z.string().nullable().optional(),
  billingMode: z.string().nullable().optional(),
});

/**
 * Tenant response wrapper schema
 */
export const TenantResponseSchema = z.object({
  success: z.boolean(),
  data: TenantDataSchema.nullable()
});
// Inferred types
export type TenantData = z.infer<typeof TenantDataSchema>;
export type TenantResponse = z.infer<typeof TenantResponseSchema>;
